/**
 * Created by calhosh on 5/4/2023
 */
import Knowledge from '../Bodies/BodyTypes/Knowledge';
import React from 'react';
import {formBodyType} from '../../../../util/uiconstants';
import {labels} from '../../../../util/utils';
import TextResponse from '../Bodies/BodyTypes/TextResponse';
import TwoToggle from '../Bodies/BodyTypes/TwoToggle';
import ThreeToggle from '../Bodies/BodyTypes/ThreeToggle';
import BodyDropDownList from '../Bodies/BodyTypes/BodyDropDownList';
import Numeric from '../Bodies/BodyTypes/Numeric';
import BodyCheckBox from '../Bodies/BodyTypes/BodyCheckBox';
import BodyRadioButton from '../Bodies/BodyTypes/BodyRadioButton';
import BodyUpdateProgressTracker from '../Bodies/Common/BodyUpdateProgressTracker';
import SingleSelectTitle from '../Bodies/BodyTypes/SingleSelectTitle';
import BodyDatePicker from '../Bodies/BodyTypes/BodyDatePicker';
import Decimal from '../Bodies/BodyTypes/Decimal';
import BodySpecial from '../Bodies/BodyTypes/BodySpecial/BodySpecial';
import SingleLineInput from '../Bodies/BodyTypes/SingleLineInput';
import PACEInputBody from '../Bodies/BodyTypes/PACEInputBody';
import UserLookupBody from '../Bodies/BodyTypes/UserLookupBody';
import BodySpecialContainer from '../Bodies/BodyTypes/BodySpecial/BodySpecialContainer';
import ISA315RelateItProcessItApp from '../Bodies/BodyTypes/BodySpecial/ISA315RelateItProcessItApp';
import Spacer from '../Bodies/BodyTypes/Spacer';
import KnowledgeTitle from '../Bodies/BodyTypes/KnowledgeTitle';
import MultiLineInput from '../Bodies/BodyTypes/MultiLineInput';
import DocumentUpload from './BodyTypes/DocumentUpload/DocumentUpload';
import DocumentUploadContainer from './BodyTypes/DocumentUpload/DocumentUploadContainer';

const knowledgeOnlyBody = (headerId, sectionId, body, isSnapshotView, isDisabled, extraProps, getBodiesBySectionId) => {
	return (
		<Knowledge
			isSnapshotView={isSnapshotView || isDisabled}
			bodyRelatedData={body}
			headerId={headerId}
			sectionId={sectionId}
			bodyId={body.id}
			extraProps={extraProps}
			getBodiesBySectionId={getBodiesBySectionId}
			{...extraProps}
		/>
	);
};

const blockerBody = (headerId, sectionId, body, isSnapshotView, isDisabled, extraProps, getBodiesBySectionId) => {
	return knowledgeOnlyBody(headerId, sectionId, body, isSnapshotView, isDisabled, extraProps, getBodiesBySectionId);
};

const textResponse = (headerId, sectionId, body, isSnapshotView, isDisabled, extraProps, getBodiesBySectionId) => {
	return (
		<TextResponse
			isSnapshotView={isSnapshotView || isDisabled}
			body={body}
			headerId={headerId}
			sectionId={sectionId}
			getBodiesBySectionId={getBodiesBySectionId}
			{...extraProps}
		/>
	);
};

const twoToggle = (headerId, sectionId, body, isSnapshotView, isDisabled, extraProps, getBodiesBySectionId) => {
	return (
		<TwoToggle
			isSnapshotView={isSnapshotView || isDisabled}
			options={body}
			headerId={headerId}
			sectionId={sectionId}
			bodyId={body?.id}
			getBodiesBySectionId={getBodiesBySectionId}
			{...extraProps}
		/>
	);
};

const threeToggle = (headerId, sectionId, body, isSnapshotView, isDisabled, extraProps, getBodiesBySectionId) => {
	return (
		<ThreeToggle
			isSnapshotView={isSnapshotView || isDisabled}
			options={body}
			headerId={headerId}
			sectionId={sectionId}
			bodyId={body?.id}
			getBodiesBySectionId={getBodiesBySectionId}
			{...extraProps}
		/>
	);
};

const dropDownList = (headerId, sectionId, body, isSnapshotView, isDisabled, extraProps, getBodiesBySectionId) => {
	return (
		<BodyDropDownList
			isSnapshotView={isSnapshotView || isDisabled}
			options={body}
			headerId={headerId}
			sectionId={sectionId}
			bodyId={body?.id}
			getBodiesBySectionId={getBodiesBySectionId}
			{...extraProps}
		/>
	);
};

const numeric = (headerId, sectionId, body, isSnapshotView, isDisabled, extraProps, getBodiesBySectionId) => {
	return (
		<Numeric
			isSnapshotView={isSnapshotView || isDisabled}
			options={body}
			headerId={headerId}
			sectionId={sectionId}
			bodyId={body?.id}
			maxLength={'15'}
			getBodiesBySectionId={getBodiesBySectionId}
			{...extraProps}
		/>
	);
};

const checkBox = (headerId, sectionId, body, isSnapshotView, isDisabled, extraProps, getBodiesBySectionId) => {
	return (
		<BodyCheckBox
			isSnapshotView={isSnapshotView || isDisabled}
			options={body}
			headerId={headerId}
			sectionId={sectionId}
			bodyId={body.id}
			getBodiesBySectionId={getBodiesBySectionId}
			{...extraProps}
		/>
	);
};

const radioButton = (headerId, sectionId, body, isSnapshotView, isDisabled, extraProps, getBodiesBySectionId) => {
	return (
		<BodyUpdateProgressTracker>
			<BodyRadioButton
				isSnapshotView={isSnapshotView || isDisabled}
				options={body}
				headerId={headerId}
				sectionId={sectionId}
				bodyId={body.id}
				getBodiesBySectionId={getBodiesBySectionId}
				{...extraProps}
			/>
		</BodyUpdateProgressTracker>
	);
};

const singleSelectTitle = (headerId, sectionId, body, isSnapshotView, isDisabled, extraProps, getBodiesBySectionId) => {
	return (
		<BodyUpdateProgressTracker>
			<SingleSelectTitle
				isSnapshotView={isSnapshotView || isDisabled}
				options={body}
				headerId={headerId}
				sectionId={sectionId}
				bodyId={body.id}
				getBodiesBySectionId={getBodiesBySectionId}
				{...extraProps}
			/>
		</BodyUpdateProgressTracker>
	);
};

const datePicker = (headerId, sectionId, body, isSnapshotView, isDisabled, extraProps, getBodiesBySectionId) => {
	return (
		<BodyDatePicker
			isSnapshotView={isSnapshotView || isDisabled}
			options={body}
			headerId={headerId}
			sectionId={sectionId}
			bodyId={body.id}
			getBodiesBySectionId={getBodiesBySectionId}
			label={labels.pickADate}
			{...extraProps}
		/>
	);
};

const decimal = (headerId, sectionId, body, isSnapshotView, isDisabled, extraProps, getBodiesBySectionId) => {
	return (
		<Decimal
			isSnapshotView={isSnapshotView || isDisabled}
			options={body}
			headerId={headerId}
			sectionId={sectionId}
			bodyId={body.id}
			getBodiesBySectionId={getBodiesBySectionId}
			{...extraProps}
		/>
	);
};

const bodySpecial = (headerId, sectionId, body, isSnapshotView, isDisabled, extraProps, getBodiesBySectionId) => {
	return (
		<BodySpecial
			isSnapshotView={isSnapshotView || isDisabled}
			bodyContent={body}
			headerId={headerId}
			sectionId={sectionId}
			bodyId={body.id}
			getBodiesBySectionId={getBodiesBySectionId}
			{...extraProps}
		/>
	);
};

const singleLineInput = (headerId, sectionId, body, isSnapshotView, isDisabled, extraProps, getBodiesBySectionId) => {
	return (
		<SingleLineInput
			options={body}
			headerId={headerId}
			sectionId={sectionId}
			bodyId={body.id}
			getBodiesBySectionId={getBodiesBySectionId}
			isSnapshotView={isSnapshotView || isDisabled}
			maxlength={'500'}
			{...extraProps}
		/>
	);
};
const paceInput = (headerId, sectionId, body, isSnapshotView, isDisabled, extraProps, getBodiesBySectionId) => {
	return (
		<PACEInputBody
			options={body}
			headerId={headerId}
			sectionId={sectionId}
			bodyId={body.id}
			getBodiesBySectionId={getBodiesBySectionId}
			isSnapshotView={isSnapshotView || isDisabled}
			{...extraProps}
		/>
	);
};

const userLookup = (headerId, sectionId, body, isSnapshotView, isDisabled, extraProps, getBodiesBySectionId) => {
	return (
		<UserLookupBody
			options={body}
			headerId={headerId}
			sectionId={sectionId}
			bodyId={body.id}
			getBodiesBySectionId={getBodiesBySectionId}
			isSnapshotView={isSnapshotView || isDisabled}
			{...extraProps}
		/>
	);
};

const bodySpecialContainer = (
	headerId,
	sectionId,
	body,
	isSnapshotView,
	isDisabled,
	extraProps,
	getBodiesBySectionId
) => {
	return (
		<BodySpecialContainer
			bodyDescriptionText={body.name}
			bodyId={body.id}
			body={body}
			bodyTypeId={body.bodyTypeId}
			cardTypeId={body.cardTypeId}
			getBodiesBySectionId={getBodiesBySectionId}
			headerId={headerId}
			isAresView={false}
			isDuplicate={body.isDuplicate}
			isSnapshotView={isSnapshotView || isDisabled}
			sectionId={sectionId}
			{...extraProps}
		/>
	);
};

const isa315RelateItProcessItApp = (
	headerId,
	sectionId,
	body,
	isSnapshotView,
	isDisabled,
	extraProps,
	getBodiesBySectionId
) => {
	return (
		<ISA315RelateItProcessItApp
			bodyDescriptionText={body.name}
			bodyId={body.id}
			body={body}
			bodyTypeId={body.bodyTypeId}
			cardTypeId={body.cardTypeId}
			getBodiesBySectionId={getBodiesBySectionId}
			headerId={headerId}
			isAresView={false}
			isDuplicate={body.isDuplicate}
			isSnapshotView={isSnapshotView || isDisabled}
			sectionId={sectionId}
			{...extraProps}
		/>
	);
};

const spacer = (headerId, sectionId, body, isSnapshotView, isDisabled, extraProps, getBodiesBySectionId) => {
	return <Spacer options={body} {...extraProps} />;
};

const knowledgeTitle = (headerId, sectionId, body, isSnapshotView, isDisabled, extraProps, getBodiesBySectionId) => {
	return (
		<KnowledgeTitle
			headerId={headerId}
			sectionId={sectionId}
			getBodiesBySectionId={getBodiesBySectionId}
			isSnapshotView={isSnapshotView || isDisabled}
			body={body}
			{...extraProps}
		/>
	);
};

const multiLineInput = (headerId, sectionId, body, isSnapshotView, isDisabled, extraProps, getBodiesBySectionId) => {
	return (
		<MultiLineInput
			options={body}
			headerId={headerId}
			sectionId={sectionId}
			bodyId={body.id}
			getBodiesBySectionId={getBodiesBySectionId}
			isSnapshotView={isSnapshotView || isDisabled}
			maxlength={'4000'}
			{...extraProps}
		/>
	);
};

const inlineRichText = (headerId, sectionId, body, isSnapshotView, isDisabled, extraProps, getBodiesBySectionId) => {
	return (
		<TextResponse
			body={body}
			getBodiesBySectionId={getBodiesBySectionId}
			headerId={headerId}
			sectionId={sectionId}
			isSnapshotView={isSnapshotView || isDisabled}
			useMinimalToolset
			{...extraProps}
		/>
	);
};

const notDisplayedPreselectedOption = (
	headerId,
	sectionId,
	body,
	isSnapshotView,
	isDisabled,
	extraProps,
	getBodiesBySectionId
) => {
	return <React.Fragment />;
};

const documentUpload = (headerId, sectionId, body, isSnapshotView, isDisabled, extraProps, getBodiesBySectionId) => {
	return (
		<DocumentUploadContainer isAresView={false}>
			<DocumentUpload
				options={body}
				headerId={headerId}
				sectionId={sectionId}
				bodyId={body.id}
				isSnapshotView={isSnapshotView}
				isDisabled={isDisabled}
				getBodiesBySectionId={getBodiesBySectionId}
				{...extraProps}
			/>
		</DocumentUploadContainer>
	);
};

const documentUploadRequired = (
	headerId,
	sectionId,
	body,
	isSnapshotView,
	isDisabled,
	extraProps,
	getBodiesBySectionId
) => {
	return (
		<DocumentUploadContainer isAresView={false}>
			<DocumentUpload
				options={body}
				headerId={headerId}
				sectionId={sectionId}
				bodyId={body.id}
				isSnapshotView={isSnapshotView}
				isDisabled={isDisabled}
				getBodiesBySectionId={getBodiesBySectionId}
				{...{...extraProps, requireValidations: true}}
			/>
		</DocumentUploadContainer>
	);
};

export const formBodyConfig = {
	[formBodyType.KnowledgeOnly]: {
		showGuidance: true,
		render: knowledgeOnlyBody
	},
	[formBodyType.Blocker]: {
		showGuidance: true,
		render: blockerBody
	},
	[formBodyType.TextResponse]: {
		showGuidance: true,
		render: textResponse
	},
	[formBodyType.ToggleTwoButton]: {
		showGuidance: true,
		render: twoToggle
	},
	[formBodyType.ToggleThreeButton]: {
		showGuidance: true,
		render: threeToggle
	},
	[formBodyType.DropDownList]: {
		showGuidance: true,
		render: dropDownList
	},
	[formBodyType.NumericTextBox]: {
		showGuidance: true,
		render: numeric
	},
	[formBodyType.PlanningMateriality]: {
		showGuidance: true,
		render: numeric
	},
	[formBodyType.TolerableError]: {
		showGuidance: true,
		render: numeric
	},
	[formBodyType.SADNominalAmount]: {
		showGuidance: true,
		render: numeric
	},
	[formBodyType.UncorrectedMisstatementsThreshold]: {
		showGuidance: true,
		render: numeric
	},
	[formBodyType.CheckBox]: {
		showGuidance: true,
		render: checkBox
	},
	[formBodyType.RadioButton]: {
		showGuidance: true,
		render: radioButton
	},
	[formBodyType.SingleSelectTitle]: {
		showGuidance: true,
		render: singleSelectTitle
	},
	[formBodyType.DatePicker]: {
		showGuidance: true,
		render: datePicker
	},
	[formBodyType.DecimalTextBox]: {
		showGuidance: true,
		render: decimal
	},
	[formBodyType.RelatedWCGWsSCOTs]: {
		showGuidance: true,
		render: bodySpecial
	},
	[formBodyType.RelatedITApps]: {
		showGuidance: true,
		render: bodySpecial
	},
	[formBodyType.WCGWTasks]: {
		showGuidance: true,
		render: bodySpecial
	},
	[formBodyType.RelatedITRiskITProcess]: {
		showGuidance: true,
		render: bodySpecial
	},
	[formBodyType.RelatedRisks]: {
		showGuidance: true,
		render: bodySpecial
	},
	[formBodyType.SingleLineInput]: {
		showGuidance: true,
		render: singleLineInput
	},
	[formBodyType.OtherBasisTypeDescription]: {
		showGuidance: true,
		render: singleLineInput
	},
	[formBodyType.PACEInput]: {
		showGuidance: true,
		render: paceInput
	},
	[formBodyType.UserLookup]: {
		showGuidance: true,
		render: userLookup
	},
	[formBodyType.ISA315SoScot]: {
		showGuidance: true,
		render: bodySpecialContainer
	},
	[formBodyType.ISA315ScotItApplication]: {
		showGuidance: true,
		render: bodySpecialContainer
	},
	[formBodyType.ISA315ItApplicationScot]: {
		showGuidance: true,
		render: bodySpecialContainer
	},
	[formBodyType.ISA315ItProcessTask]: {
		showGuidance: true,
		render: bodySpecialContainer
	},
	[formBodyType.ISA315ManageItSp]: {
		showGuidance: true,
		render: bodySpecialContainer
	},
	[formBodyType.ISA315ItProcessItRisk]: {
		showGuidance: true,
		render: bodySpecialContainer
	},
	[formBodyType.ISA315ItGCTestStrategy]: {
		showGuidance: true,
		render: bodySpecialContainer
	},
	[formBodyType.ISA315ItProcessItApplication]: {
		showGuidance: true,
		render: isa315RelateItProcessItApp
	},
	[formBodyType.Spacer]: {
		showGuidance: false,
		render: spacer
	},
	[formBodyType.KnowledgeTitle]: {
		showGuidance: true,
		render: knowledgeTitle
	},
	[formBodyType.MultiLineInput]: {
		showGuidance: true,
		render: multiLineInput
	},
	[formBodyType.InlineRichText]: {
		showGuidance: true,
		render: inlineRichText
	},
	[formBodyType.NotDisplayedPreselectedOptions]: {
		showGuidance: false,
		render: notDisplayedPreselectedOption
	},
	[formBodyType.DocumentUpload]: {
		showGuidance: true,
		render: documentUpload
	},
	[formBodyType.DocumentUploadRequired]: {
		showGuidance: true,
		render: documentUploadRequired
	}
};

export function getBodyConfiguration(formBodyTypeId) {
	return formBodyTypeId && formBodyConfig[formBodyTypeId];
}
